import { render, staticRenderFns } from "./SerialEdit.vue?vue&type=template&id=69cb62e8"
import script from "./SerialEdit.vue?vue&type=script&lang=js"
export * from "./SerialEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports